import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AuthContext from '../../context/Auth/AuthContext';
import { useHistory } from 'react-router-dom';
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
function ExternalAuth() {
  const { is_login, extAuth } = useContext(AuthContext);
  const history = useHistory();
  const queryString = new URLSearchParams(useLocation().search);
  const urlParams64 = useLocation().search

  useEffect(() => {
    if (is_login()) {
      history.push('/');
      return null;
    }

    const ciid = queryString.get('ciid')
    const cuid = queryString.get('cuid')
    const ts = queryString.get('ts')
    const sk = queryString.get('sk')

    if (!ciid || !cuid || !ts || !sk) {
      Notifications.notify('External Auth parameters missing.', ERROR_NOTIFICATION);
      history.push('/Login');
      return null;
    }

    extAuth(urlParams64, (path) => {
      history.push(path);
      return null;
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <></>;

}

export default ExternalAuth;
